import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      {/* <div className="footer_nav">
        <ul>
          <li className="footer_nav_item">
            <a href="/">Get Start</a>
          </li>
          <li className="footer_nav_item">
            <a href="/">Get Start</a>
          </li>
          <li className="footer_nav_item">
            <a href="/">Get Start</a>
          </li>
          <li className="footer_nav_item">
            <a href="/">Get Start</a>
          </li>
        </ul>
      </div> */}

      <div className="footer_content">
        <div className="footer_content_item">
          <strong>Important Disclosures. Please Read Carefully.</strong>
          <p>
            Persons facing serious financial difficulties should consider other
            alternatives or should seek out professional financial advice. This
            website is not an offer to lend. OppLoans.com is not a lender or
            lending partner and does not make loan or credit decisions.
            OppLoans.com connects interested persons with a lender or lending
            partner from its network of approved lenders and lending partners.
            OppLoans.com does not control and is not responsible for the actions
            or inactions of any lender or lending partner, is not an agent,
            representative or broker of any lender or lending partner, and does
            not endorse any lender or lending partner. OppLoans.com receives
            compensation from its lenders and lending partners, often based on a
            ping-tree model similar to Google AdWords where the highest
            available bidder is connected to the consumer. Regardless,
            OppLoans.com’s service is always free to you. In some cases, you may
            be given the option of obtaining a loan from a tribal lender. Tribal
            lenders are subject to tribal and certain federal laws while being
            immune from state law including usury caps. If you are connected to
            a tribal lender, please understand that the tribal lender’s rates
            and fees may be higher than state-licensed lenders. Additionally,
            tribal lenders may require you to agree to resolve any disputes in a
            tribal jurisdiction. You are urged to read and understand the terms
            of any loan offered by any lender, whether tribal or state-licensed,
            and to reject any particular loan offer that you cannot afford to
            repay or that includes terms that are not acceptable to you. This
            service is not available in all states. If you request to connect
            with a lender or lending partner in a particular state where such
            loans are prohibited, or in a location where OppLoans.com does not
            have an available lender or lending partner, you will not be
            connected to a lender or lending partner. You are urged to read and
            understand the terms of any loan offered by any lender or lending
            partner, and to reject any particular loan offer that you cannot
            afford to repay or that includes terms that are not acceptable to
            you. By submitting your information via this website, you are
            authorizing OppLoans.com and its partners to do a credit check,
            which may include verifying your social security number, driver
            license number or other identification, and a review of your
            creditworthiness. Credit checks are usually performed by one of the
            major credit bureaus such as Experian, Equifax and TransUnion, but
            also may include alternative credit bureaus such as Teletrack, DP
            Bureau or others. You also authorize OppLoans.com to share your
            information and credit history with a network of approved lenders
            and lending partners. Our lenders offer loans with an Annual
            Percentage Rate (APR) of 35.99% and below. For qualified consumers,
            the maximum APR (including the interest rates plus fees and other
            costs) is 35.99%. All loans are subject to the lender’s approval
            based on its own unique underwriting criteria. Example: Loan Amount:
            $4,300.00, Annual Percentage Rate: 35.99%. Number of Monthly
            Payments: 30. Monthly Payment Amount: $219.36. Total Amount Payable:
            $6,581.78 Loans include a minimum repayment plan of 12 months and a
            maximum repayment plan of 30 months.
          </p>
        </div>
        <div className="footer_content_item">
          <strong>Lender’s or Lending Partner’s Disclosure of Terms.</strong>
          <p>
            The lenders and lending partners you are connected to will provide
            documents that contain all fees and rate information pertaining to
            the loan being offered, including any potential fees for
            late-payments and the rules under which you may be allowed (if
            permitted by applicable law) to refinance, renew or rollover your
            loan. Loan fees and interest rates are determined solely by the
            lender or lending partner based on the lender’s or lending partner’s
            internal policies, underwriting criteria and applicable law.
            OppLoans.com has no knowledge of or control over the loan terms
            offered by a lender and lending partner. You are urged to read and
            understand the terms of any loan offered by any lenders and lending
            partners and to reject any particular loan offer that you cannot
            afford to repay or that includes terms that are not acceptable to
            you.
          </p>
        </div>
        <div className="footer_content_item">
          <strong>Late Payments Hurt Your Credit Score</strong>
          <p>
            Please be aware that missing a payment or making a late payment can
            negatively impact your credit score. To protect yourself and your
            credit history, make sure you only accept loan terms that you can
            afford to repay. If you cannot make a payment on time, you should
            contact your lenders and lending partners immediately and discuss
            how to handle late payments.
          </p>
        </div>
      </div>
      <div className="footer_copyRight">
        <p>Copyright © 2021 OppLoans.com - all rights reserved</p>
      </div>
    </div>
  );
};

export default Footer;
